<ul class="outlet">
  <li *ngFor="let notification of (notifications$ | async); trackBy:trackNotification" @fadeIn>
    <lng-dynamic-notification [notification]="notification" (activated)="activated(notification.id, $event)"></lng-dynamic-notification>
  </li>
</ul>
